import { SystemMailWithoutBody } from "../model/SystemMail";
import { Customer } from "../model/Customer";
import { copySystemMailsToCustomer } from "../api/systemMailClient";
import { json } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import CopyTemplateDialog from "../components/Template/TemplateTableDialog/CopyTemplateDialog";

const emptyData: {
    customerId: string;
    selectedTemplateIds: string[];
    customers: Customer[];
    onCopyResult: (data: SystemMailWithoutBody[], targetCustomerId: string) => void;
} = {
    customerId: "",
    selectedTemplateIds: [],
    customers: [],
    onCopyResult: () => {},
};

export function useCopySystemMailDialog(): [
    JSX.Element,
    (
        onCopyResult: (data: SystemMailWithoutBody[], targetCustomerId: string) => void,
        customerId: string,
        selectedTemplateIds: string[],
        customers: Customer[]
    ) => void
] {
    const { t } = useTranslation();
    const [data, setData] = useState(emptyData);
    const [open, setOpen] = useState(false);

    const copySystemMails = (
        templateIds: string[],
        targetCustomerId: string,
        onResult: (data: SystemMailWithoutBody[], targetCustomerId: string) => void
    ) => {
        copySystemMailsToCustomer(templateIds, targetCustomerId)
            .then((res) => {
                if (!res.ok) {
                    throw json(
                        { message: t("templateTable.copyTemplatesError") },
                        { status: 500 }
                    );
                }
                return res.json();
            })
            .then((responseData) => {
                onResult(responseData, targetCustomerId);
            })
            .catch((exception) => {
                console.log(exception.message);
            });
    };

    const openDialog = (
        onCopyResult: (data: SystemMailWithoutBody[], targetCustomerId: string) => void,
        customerId: string,
        selectedTemplateIds: string[],
        customers: Customer[]
    ) => {
        setData({
            customerId,
            selectedTemplateIds,
            customers,
            onCopyResult,
        });
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const executeCopy = (targetCustomerId: string) => {
        copySystemMails(data.selectedTemplateIds, targetCustomerId, data.onCopyResult);
        handleClose();
    };

    const dialog = (
        <CopyTemplateDialog
            open={open}
            onClose={handleClose}
            onSelect={executeCopy}
            customers={data.customers}
        />
    );

    return [dialog, openDialog];
}
